export default {
  getIndicadorTpl: state => {
    const dataShow = state // state.data
    return dataShow
  },
}
